import React from 'react';
import { motion } from 'framer-motion';
export const Gallery = () => {
  return <section id="gallery" className="bg-[#0A0A0A] py-32 relative" data-id="element-41">
      <div className="max-w-6xl mx-auto px-6" data-id="element-42">
        <motion.h2 initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="font-serif text-2xl md:text-3xl text-gold text-center tracking-[0.2em] uppercase mb-24 font-light" data-id="element-43">
          Portafolio
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20" data-id="element-44">
          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 1
        }} className="aspect-[4/5] overflow-hidden" data-id="element-45">
            <video src="https://cdn.magicpatterns.com/uploads/68xDZ9q8nQdANHZf4SdVUJ/✨ Luminosidad, dimensión y movimiento.Realizamos un diseño de Highlights personalizados para apo.mp4" className="w-full h-full object-cover opacity-90" autoPlay loop muted playsInline data-id="element-46" />
          </motion.div>
          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 1,
          delay: 0.2
        }} className="aspect-[4/5] overflow-hidden" data-id="element-47">
            <img src="https://cdn.magicpatterns.com/uploads/bNVtQUgBXFMNifMursNphm/Un_buen_balayage_no_empieza_con_la_decoloracion…_empieza_con_la_salud_del_cabello_✨Si_el_pelo_no.jpg" alt="Gallery" className="w-full h-full object-cover opacity-90" data-id="element-48" />
          </motion.div>
          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 1,
          delay: 0.4
        }} className="aspect-[4/5] overflow-hidden" data-id="element-49">
            <video src="https://cdn.magicpatterns.com/uploads/jgFSTjkSMGWq5PrQeMnGKT/Highlight tejidas en tonos Honey Blonde ✨🍯Una iluminación suave, elegante y llena de dimensión,.mp4" className="w-full h-full object-cover opacity-90" autoPlay loop muted playsInline data-id="element-50" />
          </motion.div>
        </div>

        <div className="text-center" data-id="element-51">
          <motion.button whileHover={{
          backgroundColor: '#C9A84C',
          color: '#0A0A0A'
        }} className="border border-gold text-gold px-10 py-4 transition-colors font-sans text-xs tracking-[0.2em] uppercase" data-id="element-52">
            Ver Instagram
          </motion.button>
        </div>
      </div>
    </section>;
};